import { GET_ACTIVE_ACADEMIC_CALENDAR } from '@/graphql';
import { useLazyQuery } from '@vue/apollo-composable';
import type { AcademicCalendar, Maybe } from '@/types/composition-functions';

export const useAcademicCalendar = ({
  activeAcademicCalendar,
}: {
    activeAcademicCalendar: { autoFetch?: boolean };
}) => {

  const {
    result: activeAcademicCalendars,
    loading: loadingActiveAcademicCalendars,
    refetch: refetchActiveAcademicCalendars,
    load: loadActiveAcademicCalendars,
  } = useLazyQuery<{ activeAcademicCalendar: Maybe<AcademicCalendar> }>(GET_ACTIVE_ACADEMIC_CALENDAR, undefined);
  if (activeAcademicCalendar.autoFetch) loadActiveAcademicCalendars();

  const academicCalendar = computed(() => activeAcademicCalendars.value?.activeAcademicCalendar);
  const currentCalendar = academicCalendar;

  return {
    activeAcademicCalendar: {
      academicCalendar,
      currentCalendar,
      loading: loadingActiveAcademicCalendars,
      refetch: refetchActiveAcademicCalendars,
      load: loadActiveAcademicCalendars,
    },
  };
};
